import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext<{
  triggerError: (error: Error) => void;
}>({
  triggerError: () => {},
});

export const useGlobalError = () => useContext(ErrorContext);

const GlobalErrorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [error, setError] = useState<Error | null>(null);
  const triggerError = (error: Error) => {
    setError(error);
  };

  return (
    <ErrorContext.Provider value={{ triggerError }}>
      {children}
      {error && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, backgroundColor: '#FFCCCB', color: 'white', padding: '10px' }}>
          <h2>Something went wrong.</h2>
          <p>{error.message}</p>
        </div>
      )}
    </ErrorContext.Provider>
  );
};

export default GlobalErrorProvider;
